import { gsap, SplitText } from 'gsap/all'
gsap.registerPlugin(SplitText)

// This Variable splits a title into lines and fades it up

export const rotateSplitTitle = (title: HTMLElement) => {
  const innerChars = new SplitText(title, {
    type: 'words, chars',
    linesClass: 'lineChild'
  })
  const outerTitle = new SplitText(title, {
    type: 'lines',
    linesClass: 'lineParent'
  })

  gsap.set(outerTitle.lines, { perspective: 2000, display: 'inline' })
  gsap.set(innerChars.chars, {
    'will-change': 'opacity, transform',
    'opacity': 0,
    'rotationX': -90,
    'yPercent': 0
  })

  return {
    chars: innerChars.chars,
    outer: outerTitle.lines
  }
}
